module.exports = __webpack_public_path__ + "img/arrow_down.e29d01a3.svg";